/**
 * The app's routing API over TanStack Router. Who may import the router packages, and how to use these exports:
 * `typescript-workspace/documentation/routing.md`.
 *
 * Each export needs a guard against misuse: its type where it can, else a `routing/*` lint rule, and its JSDoc always.
 * `routing-reference.md` lists what is left out on purpose, and what to use instead, below "What to use for what".
 *
 * A type that only describes an export's signature isn't exported here: app code names it with `ReturnType` or
 * `Parameters`, not through a second public name.
 */
export { getRouteApi } from './getRouteApi';
export { isOwnClick } from './isOwnClick';
export * from './links';
// Not `NavigationGuardRoot` or `usePendingNavigation`: only `components/NavigationGuard` imports them, from the
// module, and a second root would hold a second blocker.
export { useUnsavedChangesGuard } from './NavigationGuard';
// Not `routeNameOf`, which takes the router, or `subscribeToRouteTag`, which names a TanStack type (`router-kit`).
export { type RouteName, useRouteName } from './routeName';
export { parseSearch, stringifySearch } from './searchParams';
export { searchParam } from './searchParam';
export { isMissingSearchParamError, stringSearch } from './stringSearch';
export { useBackNavigation } from './useBackNavigation';
export { useElementScrollRestoration } from './useElementScrollRestoration';
export { type NavigationState, useHistoryState } from './useHistoryState';
export { useLocationHref } from './useLocationHref';
export { useNavigate } from './useNavigate';
export { type RouteStaticData, useRouteMatches } from './useRouteMatches';
export { useSearch } from './useSearch';
export { useSetSearch } from './useSetSearch';
